<template>
    <div class="notification_users">
        <b-row>
            <b-col>
                <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="select_user">
                    <span  class="fal  fa-eject mr-1"></span>
                    Обрати користувачів
                </button>
            </b-col>
            
            <b-col v-if="doc.id > 0">
                <button :disabled="selected_users.length === 0" class="btn btn-md btn-block btn-outline-success waves-effect waves-themed" v-on:click="send_notification">
                    <span  class="fal  fa-eject mr-1"></span>
                    Повідомлення
                </button>
            </b-col>
        </b-row>
        
        <div class="users_in" >
            <div class="" v-if="doc.id >0 ">
                <div class="panel-tag mt-2 mb-2">
                    <div id="js_change_tab_direction" class="btn-group btn-group-sm btn-group-toggle" data-toggle="buttons">
                        
                        <label class="btn btn-primary active waves-effect waves-themed cursor-pointer" v-on:click="check_uncheck(true)" data-action="" data-class="n" data-target="">
                            <input type="radio" name="radioNameTabDirection" checked="" value="nav nav-tabs"> Обрати Всі
                        </label>
                        
                        <label class="btn btn-success waves-effect waves-themed cursor-pointer"  v-on:click="check_uncheck(false)" data-action="" data-class="" data-target="">
                            <input type="radio" name="radioNameTabDirection" value="nav nav-tabs justify-content-end"> Зняти виділення
                        </label>
                    </div>
                    <div class="badge badge-primary float-right">В списку {{ selected_users.length  }} користувачів </div>
                </div>
            </div>
            
            <div class="users_list mt-3">
                <ul class="user_list_to_insert">
                    <li v-for="(item,index) in inside_users" :class="user_class(item)" class="border cursor-pointer shadow-1 mt-1 mb-2" v-on:click="select_user_notification(item)">
                        <user_block
                            del_triger="remove_customer_in_invoice"
                            :can_del="true"
                            :show_vacation=true
                            :key="item.id"
                            :user=item padding_class="pt-2 pl-2 pb-1">
                        </user_block>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Users_list from "../../../../shared/users/users_list.vue";
import user_block from "../../../../shared/user/user_block/user_block.vue";

export default {
    name: "internal_notification",
    components: {user_block, Users_list},
    props : {
        doc : {
            type : Object
        }
    },
    
    data() {
        return {
            user_select_uniq : "intenal_user_odc",
            selected_users : [],
        }
    },
    
    created() {
        EventBus.$on('remove_customer_in_invoice',this.remove_customer_in_invoice);
        
        EventBus.$on('selected_users', e => {
            if(e !== undefined && e.uniq === this.user_select_uniq) {
                this.push_selected_users(e.users);
            }
        });
        
    },
    
    methods : {
        
        push_selected_users(users) {
            
            this.selected_users = [];
            this.doc.attached_invoices = [];
            users.map(user => {
                this.doc.attached_invoices.push(user);
            });
            
            EventBus.$emit('close_u_filter');
        },
        
        select_user() {
            EventBus.$emit('load_users_filter', {
                uniq: this.user_select_uniq,
                active : this.inside_users
            });
        },
        
        check_uncheck(type) {
            if(this.doc.id == 0) {
                return '';
            }
            
            this.selected_users = [];
            if(type) {
                this.inside_users.map(user => {
                    this.selected_users.push(parseInt(user.id));
                });
            }
        },
        
        select_user_notification(user) {
            if(this.doc.id == 0) {
                return '';
            }
            
            const userId = parseInt(user.id);
            const index = this.selected_users.indexOf(userId);
            
            if (index === -1) {
                this.selected_users.push(userId);
            } else {
                this.selected_users.splice(index, 1);
            }
        },
        
        
        remove_customer_in_invoice(user) {
            let del_id = user.id;
            this.doc.attached_invoices = this.doc.attached_invoices.filter(user_in => {
                return parseInt(user_in.id) != parseInt(del_id);
            });
        },
        
        async send_notification() {
            await api.patch('/internal/docs/' + this.doc.id + '/notification',{
                'ids' : this.selected_users
            }).then(({data}) => {
                if (data.status === "operation_success") {
                    IMC_CORE.snackbar('Успішно поставлено в чергу')
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        user_class(user) {
            if(user.is_selected) {
                return 'active bg-selected-50';
            }
        },
    },
    
    computed : {
        inside_users () {
            if (this.doc.hasOwnProperty('attached_invoices')) {
                return this.doc.attached_invoices.map(user => {
                    user.is_selected = this.selected_users.includes(parseInt(user.id));
                    return user;
                });
            }
            return [];
        }
    },
    
    
}
</script>


<style scoped>

</style>